import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { hasMatch, makeStillNeededWithMatch } from './projectUtils.js';
import { projectFormatter } from './projectFormatter.js';

export const ProjectCost = createReactClass({
    propTypes: {
        project: PropTypes.object.isRequired,
        amountGiven: PropTypes.number,
    },

    render: function () {
        const project = this.props.project;
        const incomplete = parseFloat(project.costToComplete) > 0;
        const className = (hasMatch(this.props.project) ? 'cost-has-match ' : '');

        const amountGiven = this.props.amountGiven ? <div>You gave ${this.props.amountGiven}!</div> : null;
        const stillNeeded = (hasMatch(this.props.project) ? makeStillNeededWithMatch(project) : projectFormatter.formatCurrency(project.costToComplete));

        return (
            <div>
                <span className={className}>
                    <span className="project-cost">
                        {incomplete ? stillNeeded : projectFormatter.formatCurrency(project.totalPrice)}
                    </span>
                    <span className="funded-language">
                        {incomplete ? ' still needed' : ' donated'}
                    </span>
                </span>
                {amountGiven}
            </div>
        );
    },
});
